import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=77f9c468&"
import script from "./CardList.vue?vue&type=script&lang=js&"
export * from "./CardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77f9c468')) {
      api.createRecord('77f9c468', component.options)
    } else {
      api.reload('77f9c468', component.options)
    }
    module.hot.accept("./CardList.vue?vue&type=template&id=77f9c468&", function () {
      api.rerender('77f9c468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/mobile/CardList/CardList.vue"
export default component.exports